import angular from 'angular'

import template from './vd-toast-notification.html'

angular
  .module('vend.ui')
  .directive('vdToastNotification', function (vdToastNotificationService) {
    return {
      template,
      link(scope, $element, attrs) {
        attrs.$addClass('vd-toast-notification-container')
      },
      controllerAs: 'vdToastNotficationCtrl',
      bindToController: true,
      controller() {
        this.service = vdToastNotificationService
      },
    }
  })
